<template>
  <div class='home-page'>
    <div class="home-banner-box">
      <swiper :options="bannerSwiperOptions" ref="bannerSwiper" v-if='banners.length > 0'>
        <swiper-slide v-for="(banner, index) in banners" :key='banner.id'>
            <div
              class="swiper-img"
              rel="preload"
              monitor='banner'
              :monitor-banner-id='index'
            >
              <div tag="div" class="content">
                <img :src='banner.bannerPicUrl' :style='{cursor: banner.bannerUrl ? "pointer" : "auto"}' @click='openBannerUrl(banner.bannerUrl)'/>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination1 swiper-pagination-content" slot="pagination"></div>
      </swiper>
      <div class='feature'>
        <div>
          <img src='../assets/home/01.png'/>
          <div>
            <div class='feature-title'>高效稳定</div>
            <div class='feature-desc'>低延时，高品质</div>
          </div>
        </div>
        <div>
          <img src='../assets/home/02.png'/>
          <div>
            <div class='feature-title'>功能齐全</div>
            <div class='feature-desc'>功能适配全场景需求</div>
          </div>
        </div>
        <div>
          <img src='../assets/home/03.png'/>
          <div>
            <div class='feature-title'>快速集成</div>
            <div class='feature-desc'>30分钟，实现实时沟通</div>
          </div>
        </div>
      </div>
    </div>
    <div class="products">
      <p class="title">丰富的产品组合，适配多样化场景需求</p>
      <ul>
        <li
          v-for="(product, index) in products"
          :key="'product' + index"
          @click='redirect(product.url)'>
          <div class='circle'>
            <img :src="product.icon" alt="icon"/>
          </div>
          <p class="name">{{product.name}}<img src='../assets/home/arrow.png'/></p>
        </li>
      </ul>
      <button style='margin-top: 10px' class='sdk-button' @click='redirect("/development")'>SDK下载</button>
    </div>
    <div class='resolutions'>
      <p class='title'>千行百业，全场景，全互动，全平台</p>
      <ul class='resolution-title-list'>
        <li
          v-for='(item, index) in resolutions'
          :key='`resolution-title-${index}`'
          :class='{ active: resolutionIndex === index }'
          @click='resolutionIndex = index'>
          <img :src='require(`../assets/home/${item.icon}.png`)' alt='icon'/>
          <div>{{item.name}}</div>
        </li>
      </ul>
      <div class='resolution-content'>
        <span :class='{prev: true, disabled: resolutionIndex === 0}' @click='handlePrevResolution'>
          <img src='../assets/home/prev.png'/>
        </span>
        <div class='resolution' @click='handleResolutionClick'>
          <img :src='currentResolution.image' alt='image'/>
          <div>
            <div class='resolution-name'>{{currentResolution.name}}</div>
            <p class='resolution-desc' v-html='currentResolution.desc'></p>
            <ul>
              <li v-for='(r, idx) in currentResolution.list' :key='`resolution-list-${idx}`'>{{r}}</li>
            </ul>
          </div>
        </div>
        <span :class='{next: true, disabled: resolutionIndex === resolutions.length - 1}' @click='handleNextResolution'>
          <img src='../assets/home/prev.png'/></span>
      </div>
    </div>
    <div class='company-strength'>
      <p class='company-strength-title'>我们的优势</p>
      <p class='company-strength-desc'>马兰头10年+技术积淀，我们致力于追求极致的实时通信</p>
      <ul class='strengths'>
        <li class='strength' v-for='strength in strengths' :key='strength.id'>
          <img class="icon" :src="strength.image" alt="icon"/>
          <div>
            <div class='strength-title'>{{strength.title}}</div>
            <div class='strength-desc' v-html='strength.desc'></div>
          </div>
        </li>
      </ul>
    </div>
    <div class='customer-case'>
      <p class='title'>千家伙伴信任，一起选择马兰头</p>
      <img class='weiyi' src='../assets/home/22.png'/>
      <div class='ceo-say'>
        <img class='quota-start' src='../assets/home/23.png'/>
        <img class='quota-end' src='../assets/home/24.png'/>
        <p>我们在经过严格的技术测评后选择了与马兰头合作，在合作过程中，马兰头在产品性能、功能方面都表现良好，尤其是在高并发环境下的服务稳定性和高可用性都经受住了严峻的考验。</p>
      </div>
      <swiper :options="customerSwiperOptions" ref='caseSwiper'>
        <swiper-slide v-for="index of Math.ceil(customerCases.length / 14)" :key='index'>
          <div
            class="swiper-img"
            rel="preload"
            :style="{
              width: '100%',
              height: '100%',
            }"
            :monitor-banner-id='index - 1'
          >
            <div tag="div" class='content'>
              <template v-for='i of 14'>
                <div
                  class='customer-case-item'
                  v-if='(index - 1) * 14 + i <= customerCases.length'
                  :key='i'
                  @click='redirect(customerCases[(index - 1) * 14 + i - 1].url)'>
                  <img :src='customerCases[(index - 1) * 14 + i - 1].image'/>
                  <div>{{customerCases[(index - 1) * 14 + i - 1].name}}</div>
                </div>
              </template>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination2 swiper-pagination-content" slot="pagination" v-if="customerCases.length > 14"></div>
      </swiper>
    </div>
    <div class='company-news' v-if='companyNews.length > 0'>
      <div class='company-news-title'>新闻干货</div>
      <div class='news-list'>
        <img class='banner' :src='currentNew.coverPath' @click='handleNewsClick(currentNew)'/>
        <div>
          <template v-for='(data, index) in companyNews'>
            <p
              :key='data.id'
              v-if='index < 6'
              :class='{"news-title": true, active: newsIndex === index}'
              @mouseover="newsIndex = index"
              @click='handleNewsClick(data)'>{{data.title}}</p>
          </template>
        </div>
      </div>
      <div class='more-news' v-if='companyNews.length > 6'>
        <span @click='redirect("/news?type=公司动态")'>查看更多新闻</span>
      </div>
    </div>
    <div class='use'>
<!--      <p>每月10000分钟免费使用</p>-->
      <p>0启动成本</p>
      <button @click='handleUseClick'>立即使用</button>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import customerCases from '../utils/customerCases';
import { CONSOLE_SITE_URL, MEETING_SITE_URL } from '../utils/constants';
import axios from 'axios';

export default {
  name: 'HomePage',
  metaInfo: {
    title: '马兰头医学科技——云通信专家，提供专业的实时音视频PaaS服务',
    meta: [
      {
        name: 'keywords',
        content: '语音通话,视频通话,语音视频,实时消息,直播连麦,互动直播,互动白板,实时互动,即时通讯,实时音视频,实时通信,rtc,声网'
      },
      {
        name: 'description',
        content: '马兰头医学科技新一代实时通信平台,致力于实时音视频PaaS平台在不同领域的应用, 推出了远程医疗、在线教育、电力建筑、娱乐社交等一系列解决方案,4行代码即可快速搭建应用，支持私有化部署'
      },
    ]
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      bannerIndex: 0,
      caseIndex: 0,
      banners: [],
      products: [
        {
          icon: require('../assets/home/04.png'),
          name: '实时语音',
          url: '/product/ssyy',
        },
        {
          icon: require('../assets/home/05.png'),
          name: '实时视频',
          url: '/product/sssp',
        },
        {
          icon: require('../assets/home/06.png'),
          name: '互动白板',
          url: '/product/hdbb',
        },
        {
          icon: require('../assets/home/07.png'),
          name: '互动直播',
          url: '/product/hdzb',
        },
        {
          icon: require('../assets/home/08.png'),
          name: '云端录制',
          url: '/product/ydlz',
        },
        {
          icon: require('../assets/home/09.png'),
          name: '即时通讯',
          url: '/product/jstx',
        },
      ],
      resolutions: [
        {
          name: '远程医疗',
          icon: '10',
          image: require('../assets/resolution/02.png'),
          desc: `<div>解决远程医疗行业应用开发者的三大难题：研发难度大，运维成本高，开发周期长</div>
            <div>融合远程就诊三座壁垒：医院、医生、患者</div>`,
          list: ['远程会诊', '在线复诊', '远程医疗培训', '手术示教', '互联网医院', '家庭问诊', '智能诊疗终端'],
          url: '/resolution/telemedicine',
        },
        {
          name: '在线教育',
          icon: '11',
          image: require('../assets/resolution/01.png'),
          desc: '互动沉浸式线上课堂，集视频、语音、文档、课件共享于一体。打破传统授课时间、空间、地域限制，让每一位学生，得到优质的教育',
          list: ['大班直播课', '互动小班课', '双师课堂', '1V1授课'],
          url: '/resolution/onlineEducation',
        },
        {
          name: '电力电工',
          icon: '12',
          image: require('../assets/resolution/05.png'),
          desc: '提高电网在可靠性、技术、远程协同等方面的精益化管理水平',
          list: ['生产检修管理', '智能监管'],
          url: '/resolution/powerIndustry',
        },
        {
          name: '互动娱乐',
          icon: '13',
          image: require('../assets/resolution/03.png'),
          desc: '短视频、直播带货、多人在线小游戏…多种互动新玩法。马兰头高品质音视频能力，助力新社交场景及大流量变现',
          list: ['实时在线多人游戏', '主播连麦', '在线K歌', '游戏直播', '直播带货', '多人视频'],
          url: '/resolution/socialEntertainment',
        },
        // {
        //   name: '视频会议',
        //   icon: '14',
        //   image: '',
        //   desc: '多种互动方式，模拟真实现场会议体验，一键即可开始即时会议',
        //   list: ['最高4K清晰度', '极低延迟', '抗丢包'],
        //   url: require('@/assets/resolution/02.png'),
        // },
        {
          name: '医学会议',
          icon: '15',
          image: require('@/assets/resolution/04.png'),
          desc: '六大特色，打造专业的医学学术会议直播互动体验',
          list: ['线上直播互动', '专属学分通道', '4K高清视频', '会议录播', '手术直播', '会议服务管家'],
          url: '/resolution/medicalTreatment',
        },
        {
          name: '公检法',
          icon: '25',
          image: require('@/assets/resolution/06.png'),
          desc: '针对公检法等行业，提供基于实时音视频技术的远程接访、远程庭审、远程审判执行、远程指挥调度、情指勤一体化等系统平台解决方案。提高司法人员的办案效率，降低司法成本',
          list: ['远程接访', '远程智慧庭审', '远程可视化指挥调度', '远程执行', '情指勤一体化'],
          url: '/resolution/publicSecurityOrgans',
        },
      ],
      resolutionIndex: 0,
      strengths: [
        { id: 1, image: require('../assets/home/16.png'), title: '快速集成', desc: '标准化的开放接口，方便按照业务需求快速、灵活地集成到各类应用中' },
        { id: 2, image: require('../assets/home/17.png'), title: '低成本', desc: '无需自建技术团队，一站式快速接入，获取音视频及互动相关功能服务，搭建周期短' },
        { id: 3, image: require('../assets/home/18.png'), title: '技术卓越', desc: '超过十年的音视频领域技术积累深耕，支持十万级大并发，超强的弱网对抗能力' },
        { id: 4, image: require('../assets/home/19.png'), title: '私有化部署支持', desc: '音视频传输、存储均可在用户专网内完成，适用于金融监管、政企服务、医疗健康等对安全有严格要求的场景' },
        { id: 5, image: require('../assets/home/20.png'), title: '一对一专家技术服务', desc: '提供深度咨询服务，结合客户需求制定高性价比解决方案' },
        { id: 6, image: require('../assets/home/21.png'), title: '一对一深度技术支持', desc: '核心团队主导客户服务，全时段快速响应，提供售前咨询、集成测试与售后升级等客户全生命周期服务，深度协助解决技术难题' },
      ],
      customerCases: customerCases,
      companyNews: [],
      newsIndex: 0,
    }
  },
  computed: {
    bannerSwiper() {
      return this.$refs.bannerSwiper.swiper;
    },
    caseSwiper() {
      return this.$refs.caseSwiper.swiper;
    },
    bannerSwiperOptions() {
      return this.getSwiperOptions('.swiper-pagination1', {
        on: {
          slideChange: () => {
            this.bannerIndex =
              (this.bannerSwiper && this.bannerSwiper.realIndex) || 0;
          },
        },
      })
    },
    customerSwiperOptions() {
      return this.getSwiperOptions('.swiper-pagination2', {
        autoplay: false,
        on: {
          slideChange: () => {
            this.caseIndex =
              (this.caseSwiper && this.caseSwiper.realIndex) || 0;
          },
        }
      });
    },
    currentResolution() {
      return this.resolutions[this.resolutionIndex] || {};
    },
    currentNew() {
      return this.companyNews[this.newsIndex];
    },
  },
  mounted() {
    this.getBanners();
    this.getNews();
    this.caseSwiper.slideTo(1, 1000, false);
  },
  methods: {
    getBanners() {
      axios.post('/api/portal/banner/list', {
        pageNumber: 1,
        pageSize: 10,
        status: 1
      }).then(res => {
        const { code, data, flag } = res.data;
        if (code === 0 && flag === 0) {
          const { results } = data;
          this.banners = (results || []).sort((a, b) => {
            return a.orderNum - b.orderNum;
          });
        } else {
          this.banners = [];
        }
      })
    },
    openBannerUrl(url) {
      if (url) {
        url = /^http/.test(url) ? url : `http://${url}`;
        window.open(url);
      }
    },
    getNews() {
      axios.post('/api/portal/info/list', {
        pageNumber: 1,
        pageSize: 10,
      }).then(res => {
        const { code, data, flag } = res.data;
        if (code === 0 && flag === 0) {
          const { results } = data;
          this.companyNews = results || [];
        } else {
          this.companyNews = [];
        }
      })
    },
    getSwiperOptions(el, options) {
      return {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        watchSlidesProgress: true,
        updateOnImagesReady: false,
        preloadImages: false,
        autoplayDisableOnInteraction: true,
        loop: true,
        pagination: {
          el,
          clickable: true,
          // type: 'custom',
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom">
                <span class='banner__pagination--timing'></span>
              </span>`;
          },
        },
        observeParents: true,
        ...options,
      }
    },
    handlePrevResolution() {
      if (this.resolutionIndex === 0) {
        return;
      } else {
        this.resolutionIndex--;
      }
    },
    handleNextResolution() {
      if (this.resolutionIndex === this.resolutions.length - 1) {
        return;
      } else {
        this.resolutionIndex++;
      }
    },
    handleResolutionClick() {
      window.location.href = this.currentResolution.url;
    },
    handleNewsClick(data) {
      this.redirect(`/news/detail/${data.id}`);
    },
    handleUseClick() {
      window.open(CONSOLE_SITE_URL);
    }
  },
}
</script>

<style lang="less">
.home-page {
  text-align: center;
  min-width: 700px;
  > div {
    &:nth-of-type(odd) {
      background: #fafafa;
    }
    &:nth-of-type(even) {
      background: #fff;
    }
  }
  button {
    height: 40px;
    min-width: 140px;
    padding-left: 15px;
    padding-right: 15px;
    background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
    border-radius: 25px;
    border: none;
    color: #fff;
    cursor: pointer;
    outline: none;
    font-size: 16px;
    &:hover {
      opacity: 0.9;
    }
  }
  .swiper-pagination-bullets {
    .swiper-pagination-bullet{
      opacity: 1;
      background-color: hsla(0,0%,100%,.3);
      filter: alpha(opacity=100);
      overflow: hidden;
      position: relative;
      transition: all 0.3s;
      .banner__pagination--timing{
        position: absolute;
        left: 0;
        top: 0;
        transform: translate3d(-100%,0,0);
        display: inline-block;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(90deg, #8DA8FF 0%, #ACE3FF 100%);
      }
    }
  }
  .swiper-pagination-bullet-active{
    background-color: hsla(0,0%,100%,.3);
    filter: alpha(opacity=100);
    .banner__pagination--timing{
      transition: transform 3s ease;
      transition: transform 3s ease,-webkit-transform 3s ease,-moz-transform 3s ease;
      transition-timing-function: linear;
      transform: translate3d(0,0,0) !important;
    }
  }
  .swiper-pagination-content {
    span {
      margin-right: 20px;
      margin-left: 0;
      width: 80px;
      height: 3px;
      border-radius: inherit;
      height: 36px;
      padding: 17px 0 16px;
      background-clip: content-box;
    }
  }

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to{
    opacity: 0;
    transform: translateY(40px);
  }
  .home-banner-box {
    position: relative;
    .swiper-container{
      height: 400px;
      padding-bottom: 52px;
      padding-top: 20px;
      background: linear-gradient(134deg,#2544a1 3%, #152664 96%);
      .swiper-wrapper {
        height: 100%;
        // background: url('@{imgPath}/icon/icon-banner-default.png');
        background-position: center;
        background-repeat: no-repeat;
      }
      .swiper-img {
        overflow: hidden;
        background: linear-gradient(134deg,#2544a1 3%, #152664 96%);
        width: 100%;
        height: 100%;
        .content {
          width: 1030px;
          margin: 0 auto;
          height: 300px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        // .content{
        //   margin: 0 auto;
        //   width: 1180px;
        //   text-align: left;
        //   position: relative;
        //   height: 100%;
        //   display: flex;
        //   justify-content: space-between;
        //   align-items: center;
        //   >div {
        //     height: 100%;
        //     display: flex;
        //     flex-direction: column;
        //     justify-content: center;
        //     align-items: flex-start;
        //     width: 600px;
        //     h3{
        //       font-size: 32px;
        //       color: #FFFFFF;
        //       font-weight: 600;
        //     }
        //     p{
        //       margin-top: 20px;
        //       font-size: 18px;
        //       color: #FFFFFF;
        //       font-weight: 400;
        //       line-height: 29px;
        //     }
        //     button{
        //       margin-top: 40px;
        //       transition: all 0.3s;
        //     }
        //     .sub-button {
        //       background: transparent;
        //       border: 2px solid #ffffff;
        //       margin-left: 30px;
        //     }
        //   }
        //   img {
        //     width: 300px;
        //     height: 300px;
        //   }
        // }
      }
      .swiper-pagination-bullets {
        bottom: 56px !important;
      }
    }
    .feature {
      position: absolute;
      left: 50%;
      bottom: -103px;
      transform: translate(-50%, 0);
      height: 155px;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 3px 0px #e2e7f5;
      color: #666666;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 2;
      width: 1149px;
      >div {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 115px;
          height: 115px;
          margin-right: 15px;
        }
        .feature-title {
          font-size: 18px;
          line-height: 25px;
          font-weight: 600;
          color: #0e2267;
          text-align: left;
        }
        .feature-desc {
          font-size: 16px;
          line-height: 22px;
          margin-top: 10px;
          color: #666666;
          font-weight: 400;
        }
      }
    }
  }
  .products {
    width: 760px;
    margin: 0 auto;
    padding-top: 143px;
    padding-bottom: 40px;
    text-align: center;
    .title {
      font-size: 32px;
      font-weight: 600;
      color: #333;
    }
    ul {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      li {
        width: 200px;
        height: 200px;
        background: #fcfdff;
        border-radius: 10px;
        box-shadow: 0px 0px 8px 0px rgba(210,221,231,0.50);
        margin-bottom: 20px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        &:hover {
          border: 2px solid #b1c4ff;
          .circle {
            background: #ecf1ff;
          }
          .name img {
            display: inline-block;
          }
        }
        &:not(:nth-of-type(3n)) {
          margin-right: 60px;
        }
        .circle {
          width: 110px;
          height: 110px;
          margin: 0 auto;
          background: rgba(236,241,255,0.38);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 60px;
            height: 60px;
          }
        }
        .name {
          margin-top: 19px;
          font-size: 18px;
          font-weight: 400;
          color: #666;
          position: relative;
          img {
            display: none;
            position: absolute;
            width: 20px;
            height: 20px;
            right: 30px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
  .resolutions {
    background: #fafafa;
    padding: 40px 0;
    .title {
      font-size: 32px;
      font-weight: 600;
      text-align: center;
      color: #333333;
    }
    .resolution-title-list {
      display: flex;
      justify-content: center;
      margin-top: 40px;
      li {
        text-align: center;
        color: #999999;
        cursor: pointer;
        img {
          width: 55px;
          height: 55px;
          display: inline-block;
          opacity: 0.5;
        }
        div {
          margin-top: 11px;
          font-size: 18px;
          font-weight: 400;
        }
        &:hover, &.active {
          color: #3B72F2;
          img {
            opacity: 1;
          }
        }
        &:not(:last-child) {
          margin-right: 60px;
        }
      }
    }
    .resolution-content {
      display: flex;
      width: 1200px;
      margin: 48px auto 0;
      align-items: flex-start;
      .prev, .next {
        width: 60px;
        height: 60px;
        background: #f1f4fd;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 185px;
        &:not(.disabled):hover {
          opacity: 0.9;
        }
        &.disabled {
          cursor: not-allowed;
        }
        img {
          width: 26px;
          height: 26px;
        }
        &.next img {
          transform: rotate(180deg);
        }
      }
      .resolution {
        margin: 0 40px;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        cursor: pointer;
        img {
          width: 430px;
          height: 430px;
        }
        > div {
          flex: 1;
          text-align: left;
          margin-left: 156px;
          .resolution-name {
            font-size: 21px;
            font-weight: 600;
            color: #333333;
          }
          .resolution-desc {
            margin-top: 24px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 29px;
            margin-bottom: 40px;
          }
          ul li {
            font-size: 18px;
            font-weight: 400;
            color: #666666;
            line-height: 34px;
            position: relative;
            padding-left: 18px;
            &:before {
              content: '';
              width: 8px;
              height: 8px;
              background: #3B72F2;
              border-radius: 50%;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }
  .company-strength {
    padding: 40px 0 0;
    margin: 0 auto;
    width: 1152px;
    .company-strength-title {
      font-size: 32px;
      color: #333333;
      font-weight: 600;
      text-align: center;
    }
    .company-strength-desc {
      margin-top: 20px;
      font-size: 18px;
      font-weight: 400;
      text-align: center;
      color: #333333;
    }
    .strengths {
      margin-top: 50px;
      display: flex;
      flex-wrap: wrap;
      .strength {
        width: 50%;
        display: flex;
        align-items: flex-start;
        margin-bottom: 50px;
        &:nth-of-type(odd) {
          padding-right: 70px;
        }
        &:nth-of-type(even) {
          padding-left: 70px;
        }
        img {
          width: 65px;
          height: 65px;
          margin-right: 38px;
        }
        >div {
          flex: 1;
          text-align: left;
          .strength-title {
            font-size: 21px;
            font-weight: 600;
            color: #333;
          }
          .strength-desc {
            font-size: 18px;
            font-weight: 400;
            color: #666;
            line-height: 29px;
            margin-top: 20px;
          }
        }
      }
    }
  }
  .customer-case {
    background: #fafafa;
    padding: 40px 0 30px;
    .title {
      font-size: 32px;
      color: #333333;
      font-weight: 600;
      text-align: center;
    }
    .weiyi {
      width: 180px;
      height: 60px;
      margin: 55px auto 50px;
      display: block;
    }
    .ceo-say {
      font-size: 18px;
      font-weight: 400;
      color: #333;
      line-height: 29px;
      width: 1100px;
      padding: 0 100px;
      margin: 0 auto;
      position: relative;
      text-align: left;
      .quota-start, .quota-end {
        position: absolute;
        width: 50px;
        height: 50px;
        left: 30px;
        top: -20px;
        &.quota-end {
          top: auto;
          left: auto;
          right: 30px;
          bottom: -20px;
        }
      }
    }
    .swiper-container{
      height: 210px;
      width: 1148px;
      margin: 32px auto 0;
      .swiper-wrapper {
        height: 100%;
      }
      .swiper-img {
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        .content{
          display: flex;
          flex-wrap: wrap;
          .customer-case-item {
            width: 152px;
            margin: 0 14px 11px 0;
            padding: 10px;
            border: 1px solid rgb(234,234,234);
            background: #fff;
            color: rgb(234,234,234);
            cursor: pointer;
            &:nth-of-type(7n) {
              margin-right: 0;
            }
            img {
              height: 40px;
            }
            > div {
              font-weight: 300;
              color: #979696;
              cursor: pointer;
            }
          }
        }
      }
      .swiper-pagination-bullets {
        bottom: 0px !important;
      }
      .swiper-pagination-bullets .swiper-pagination-bullet{
        background-color: hsla(30%,30%,70%,.3);
      }
    }
  }
  .company-news {
    margin-bottom: 4px;
    padding: 40px 0;
    text-align: center;
    .company-news-title {
      font-size: 36px;
      margin-bottom: 50px;
      font-weight: 600;
      color: #333;
    }
    .news-list {
      display: flex;
      width: 1150px;
      margin: 0 auto;
      align-items: center;
      img {
        width: 503px;
        height: 295px;
        margin-right: 69px;
        cursor: pointer;
      }
      >div {
        width: 578px;
        p {
          cursor: pointer;
          padding-left: 28px;
          position: relative;
          text-align: left;
          font-size: 18px;
          font-weight:400;
          color: #333;
          line-height: 33px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &:not(:last-child) {
            margin-bottom: 19px;
          }
          &:hover, &.active {
            color: #3B72F2;
          }
          &:before {
            content: '';
            width: 8px;
            height: 8px;
            background: #5291ff;
            border-radius: 50%;
            left: 0;
            top: 50%;
            position: absolute;
            transform: translateY(-50%);
          }
        }
      }
    }
    .more-news {
      width: 1150px;
      margin: 20px auto 0;
      text-align: right;
      span {
        cursor: pointer;
        color: #3b72f2;
        line-height: 25px;
        color: #3B72F2;
        font-size: 18px;
        font-weight: 400;
        text-decoration: underline;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  .use {
    padding: 40px 0;
    p {
      font-size: 38px;
      font-weight: 200;
      color: #3b72f2;
      line-height: 53px;
      letter-spacing: 3px;
      &:first-child {
        margin-bottom: 10px;
      }
    }
    button {
      margin-top: 20px;
    }
  }
}
</style>
